import { css } from 'emotion';

export const ihiSection = css`
	padding-top: 1em;
`;



// WEBPACK FOOTER //
// ./src/components/Patient/styles.js